export function throttle(callback: any, wait: number, immediate = false) {
  let timeout = null
  let initialCall = true

  return function (...args: any[]) {
    const callNow = immediate && initialCall
    const next = (): void => {
      callback.apply(this, args)
      timeout = null
    }

    if (callNow) {
      initialCall = false
      next()
    }

    if (!timeout) {
      timeout = setTimeout(next, wait)
    }
  }
}

export function getScrollPercent(event: Event): number {
  const { target } = event
  const { documentElement, body } = target as Document
  const {
    scrollTop: documentElementScrollTop,
    scrollHeight: documentElementScrollHeight,
    clientHeight,
  } = documentElement
  const { scrollTop: bodyScrollTop, scrollHeight: bodyScrollHeight } = body
  const percent =
    ((documentElementScrollTop || bodyScrollTop) / ((documentElementScrollHeight || bodyScrollHeight) - clientHeight)) *
    100
  return Math.ceil(percent)
}
